import React from 'react';
import { Card, CardContent, CardActions, Skeleton, Box } from '@mui/material';

interface PropertyCardSkeletonProps {
  showActions?: boolean;
  compact?: boolean;
  orientation?: 'vertical' | 'horizontal';
}

const PropertyCardSkeleton: React.FC<PropertyCardSkeletonProps> = ({ 
  showActions = true, 
  compact = false,
  orientation = 'vertical' 
}) => {
  const isHorizontal = orientation === 'horizontal';

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: isHorizontal ? 'row' : 'column',
      }}
    >
      <Skeleton 
        variant="rectangular" 
        width={isHorizontal ? '30%' : '100%'}
        height={isHorizontal ? 'auto' : (compact ? 180 : 240)} 
        sx={{ 
          flexShrink: 0,
          minWidth: isHorizontal ? { xs: 120, sm: 200 } : undefined,
          minHeight: isHorizontal ? 200 : undefined
        }}
      />
      
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, width: isHorizontal ? '70%' : '100%' }}>
        <CardContent sx={{ flexGrow: 1 }}>
          <Skeleton variant="text" height={32} width="80%" sx={{ mb: 1 }} />
          <Skeleton variant="text" height={40} width="40%" sx={{ mb: 2 }} />
          <Skeleton variant="text" height={24} width="60%" sx={{ mb: 2 }} />
          
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <Skeleton variant="rectangular" width={60} height={24} />
            <Skeleton variant="rectangular" width={60} height={24} />
            <Skeleton variant="rectangular" width={80} height={24} />
          </Box>
          
          {(!compact || isHorizontal) && (
            <>
              <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                <Skeleton variant="rounded" width={80} height={24} />
                <Skeleton variant="rounded" width={80} height={24} />
              </Box>
              <Skeleton variant="text" height={40} />
            </>
          )}
        </CardContent>
        
        {showActions && (
          <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
            <Skeleton variant="rectangular" width={80} height={30} />
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Skeleton variant="circular" width={30} height={30} />
              <Skeleton variant="circular" width={30} height={30} />
            </Box>
          </CardActions>
        )}
      </Box>
    </Card>
  );
};

export default PropertyCardSkeleton;
